export default {"src":"/_next/static/media/xmo.dd983301.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};